<template>
  <base-section
    id="pro-features"
  >
    <v-img
      :src="require('@/assets/images/fahagola_logo.png')"
      class="mx-auto mb-8"
      max-width="128"
    />

    <base-section-heading title="A Propos">
      <strong>Fahagola</strong>, ou l'ancien temps en malgache, reflète notre objectif qui est de laisser une trace de notre existence dans ce monde, et même ailleurs. Notre site permet de sauvegarder des souvenirs du passé particuliers, ou des avancés technologiques indubitables à l'aide des fameuses capsules temporelles.
      Marquer l'histoire avec <strong>Fahagola</strong>.
      Notre site-web prend en main vos souvenirs les plus précieux pour les envoyer dans le futur.
      Une réminiscence d'un monde passé, un voyage dans le futur des vestiges du présent.
      Faites votre choix sur quelles données, jusqu'à quand voulez vous laisser une trace de ces données, et où souhaiteriez vous les garder. Nous nous occupons du reste.
    </base-section-heading>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProChart',
  }
</script>
